import { connect } from 'react-redux'

import { RootState } from '../types/'
import { TradingAction } from '../actions'
import { chartReady } from '../actions/commonActions'
import BondTradingChart from '../components/BondTradingChart'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  const locale = rootState.appConfig.locale
    ? rootState.appConfig.locale
    : rootState.tradingAccounts.viewer.locale
  const serverType = rootState.tradingAccounts.viewer.accounts.find(
    acc => acc.login === rootState.appConfig.accountLogin
  )!.serverType

  const selectedBondSymbol = rootState.bondListState.selectedBond
    ? rootState.bondListState.selectedBond.mt4Symbol
    : 'BTCEUR'

  const chartLocalesMap: any = {
    da: 'da_DK',
    nl: 'nl_NL',
    id: 'id_ID',
    ms: 'ms_MY',
    hi: 'en',
    ph: 'en',
  }

  return {
    appConfig: rootState.appConfig,
    serverType,
    symbol: selectedBondSymbol,
    resolution: '240',
    timeframe: '60D',
    type: 1,
    locale: chartLocalesMap[locale] || locale,
    // positions: rootState.trades,
    assets: mt4.assets, // rootState.symbolsSubscriptions,
    currency: state.currency,
    visibleRange: state.range,
    selectedPosition: state.selectedPosition,
    positionsOpened: state.positionsOpened,
    positionExpanded: state.positionExpanded,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    //        onChangeSymbol: (symbol: string) => dispatch(changeSymbol(symbol)),
    onChartReady: () => dispatch(chartReady()),
    //        onSelectPosition: (order: number, expanded?: boolean) => dispatch(selectPosition(order, expanded)),
    //        onInputStopLoss: (order: number, value: number) => dispatch(inputPositionSL(order, value)),
    //        onInputTakePorfit: (order: number, value: number) => dispatch(inputPositionTP(order, value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BondTradingChart)
